import { useContext, FunctionComponent } from 'react'

import PositionContainer from 'components/PositionContainer'
import { ProductVariantContext } from 'components/ProductVariantProvider'

const Background: FunctionComponent = () => {
  const { currentVariant } = useContext(ProductVariantContext)

  return (
    <PositionContainer
      position="fixed"
      top="0"
      left="0"
      right="0"
      bottom="0"
      background={currentVariant.theme.colors.backgroundPrimary}
    />
  )
}

export default Background
